<script setup lang="ts">
import FiatWalletsContainer from './containers/FiatWalletsContainer.vue'
</script>

<template>
  <FiatWalletsContainer />
</template>
